import React, {useContext} from 'react'
import { Link } from 'react-router-dom'
import Map from '../mencontact/Map'
import { LanguageContext } from '../../LanguageContext';

function Main() {
    const { language, setLanguage } = useContext(LanguageContext);
    return (
    <>
    {/* {language==='en'?'':''} */}
        <footer className="footer-bg footer-p pt-70" style={{ backgroundColor: "#125875", backgroundImage: "url(assets/img/bg/footer-bg.png)" }} >
            <div className="footer-top pb-50">
                <div className="container">
                <div className="row justify-content-between">
                    
                    <div className="col-xl-3 col-lg-3 col-sm-6">
                        <div className="footer-widget mb-30">
                            <div className="f-widget-title">
                            <h2>{language==='en'?'Quick Links':'त्वरित संपर्क'}</h2>
                            </div>
                            <div className="footer-link">
                            <ul>
                                <li>
                                    <Link to="https://iittp.plumerp.co.in/prod/iittirupati/" target='_blank'>{language==='en'?'Workflow System':'कार्यप्रवाह प्रणाली'}</Link>
                                </li>
                                <li>
                                    <Link to="https://iittp.ac.in/eu/" target='_blank'>{language==='en'?'Engineering Unit':'अभियांत्रिकी एकक'}</Link>
                                </li>
                                <li>
                                    <Link to="https://intranet.iittp.ac.in/" target='_blank'>{language==='en'?'Intranet Website':'इंट्रानेट वेबसाइट'}</Link>
                                </li>
                                <li>
                                    <Link to="/health-center"> {language==='en'?'Health Center':'स्वास्थ्य केंद्र'}</Link>
                                </li>
                                <li>
                                    <Link to="https://oia.iittp.ac.in/" target='_blank'>{language==='en'?'Office of International Affairs':'अंतर्राष्ट्रीय मामलों का कार्यालय'}</Link>
                                </li>
                                <li>
                                    <Link to="/alumni_centres" target='_blank'>{language==='en'?'Alumni Centres':'पूर्व छात्र केंद्र'}</Link>
                                </li>
                                <li>
                                    <Link to="https://iittnif.com/" target='_blank'>{language==='en'?'Technology Innovation Hub':'प्रौद्योगिकी नवाचार केंद्र'}</Link>
                                </li>
                                <li>
                                    <Link to="https://iittp.ac.in/CentralLibrary" target='_blank'>{language==='en'?'Central Library':'केंद्रीय पुस्तकालय'}</Link>
                                </li>
                                
                                
                                
                                {/* <li>
                                    <Link to="/contact">HelpDesk @ Girl Students</Link>
                                </li> */}
                                
                                <li>
                                    <Link to="/creche">{language==='en'?'Creche':'शिशु-गृह'}</Link>
                                </li>
                                <li>
                                    <Link to="/kvsiittcampus">{language==='en'?'KV IIT Tirupati Campus':'केवी आईआईटी तिरुपति परिसर'}</Link>
                                </li>
                                
                            </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-sm-6">
                    <div className="footer-widget mb-30">
                            <div className="f-widget-title">
                            <h2>{language==='en'?'Important Links':'महत्वपूर्ण लिंक'}</h2>
                            </div>
                            <div className="footer-link">
                            <ul>
                            <li>  <Link to="/rajbhasha" target='_self'>{language==='en'?'Rajbhasha':'राजभाषा'}</Link>
                                </li>
                                <li>
                                    <Link to="/anti-ragging" target='_blank'>{language==='en'?'Anti Ragging Committee':'एंटी रैगिंग समिति'}</Link>
                                </li>
                                <li>
                                    <Link to="/internalcomplaintcommittee">{language==='en'?(<>Internal Complaints Committee <br />(Anti Sexual Harrasment)</>):(<>आंतरिक शिकायत समिति <br/> (यौन उत्पीड़न के विरुद्ध)</>)}</Link>
                                </li>
                                <li>
                                    <Link to="/rti" target='_blank'>{language==='en'?'Right to Information':'सूचना का अधिकार'}</Link>
                                </li>
                                <li>
                                    <Link to="/liaison-officers" target='_blank'>{language==='en'?'SC/ST/OBC Liaison Officers/Cell':'एससी/एसटी/ओबीसी संपर्क अधिकारी/सेल'}</Link>
                                </li>
                                <li>
                                    <Link to="/rti-section-4" target='_blank'>{language==='en'?'Act and Statutes':'अधिनियम और क़ानून'}</Link>
                                </li>
                                <li>
                                    <Link to="/help-desk-girl-students">{language==='en'?'Help Desk @ Girl Students':'हेल्प डेस्क @ छात्राएं'}</Link>
                                </li>
                                
                                <li>
                                    <Link to="https://iittp.ac.in/gcu">{language==='en'?'Guidance & Counseling Unit':'मार्गदर्शन और परामर्श इकाई'}</Link>
                                </li>
                               
                               

                            </ul>
                            </div>
                        </div>
                    
                    </div>
                    <div className="col-xl-3 col-lg-3 col-sm-6">
                    <div className="footer-widget mb-30">
                            <div className="f-widget-title">
                            <h2>{language==='en'?'Explore':'अन्वेषण'}</h2>
                            </div>
                            <div className="footer-link">
                            <ul>
                                <li>
                                    <Link to="https://cc.iittp.ac.in/" target='_blank'>{language==='en'?'Computer center':'कप्यूटर केंद्र'}</Link>
                                </li>
                                <li>
                                    <Link to="/academic-calender">{language==='en'?'Academic Calendar':'शैक्षणिक कैलेंडर'}</Link>
                                </li>
                                <li>
                                    <Link to="https://iittp.ac.in/medha" target='_blank'>{language==='en'?'Medha':'मेधा'}</Link>
                                </li>
                                <li>
                                    <Link to="https://iittp.ac.in/spicmacay" target='_blank'>{language==='en'?'Spic Macay':'स्पिक मैके'}</Link>
                                </li>
                                <li>
                                    <Link to="/swayamprabha" target='_blank'>{language==='en'?'SWAYAM Prabha':'स्वयंप्रभा'}</Link>
                                </li>
                                <li>
                                    <Link to="/tenders">{language==='en'?'Tenders':'निविदाएं'}</Link>
                                </li>
                                
                                <li>
                                    <Link to="/infrastructure-at-transit-campus">{language==='en'?'Campus':'कैंपस'}</Link>
                                </li>
                               
                                <li>
                                    <Link to="/annualreports">{language==='en'?'Annual Report':'वार्षिक प्रतिवेदन '}</Link>
                                </li>
                                <li>
                                    <Link to="https://old.iittp.ac.in/moodle" target='_blank'>{language==='en'?'Moodle':'मूडल '}</Link>
                                </li>

                            </ul>
                            </div>
                        </div>
                    {/* <div className="footer-widget mb-30">
                        <div className="f-widget-title">
                        <h2>Latest Post</h2>
                        </div>
                        <div className="recent-blog-footer">
                        <ul>
                            <li>
                            <div className="thum">
                                {" "}
                                <img src="assets/img/blog/s-blogimg-01.png" alt="img" />
                            </div>
                            <div className="text">
                                {" "}
                                <Link to="/blog-details">
                                Nothing impossble to need hard work
                                </Link>
                                <span>7 March, 2020</span>
                            </div>
                            </li>
                            <li>
                            <div className="thum">
                                {" "}
                                <img src="assets/img/blog/s-blogimg-02.png" alt="img" />
                            </div>
                            <div className="text">
                                {" "}
                                <Link to="/blog-details">
                                Nothing impossble to need hard work
                                </Link>
                                <span>7 March, 2020</span>
                            </div>
                            </li>
                        </ul>
                        </div>
                    </div> */}
                    </div>
                    

                    <div className="col-xl-3 col-lg-3 col-sm-6">
                    <div className="footer-widget mb-30">
                        <div className="f-widget-title">
                        <h2>{language==='en'?'Contact Us':'संपर्क करें'}</h2>
                        </div>
                        <div className="f-contact">
                        <ul>
                            <li>
                            <i className="icon fal fa-phone" />
                            <span>
                                <span>{language==='en'?'Administration':'प्रशासन'}</span>
                                <br />
                                <Link to="tel:0877-250-3507">0877-250-3507</Link>
                            </span>
                            </li>
                            <li>
                            <i className="icon fal fa-envelope" />
                            <span>
                                <span>{language==='en'?'E-Mail address':'ई-मेल पता'}</span>
                                <br />
                                <Link to="mailto:iittirupati@iittp.ac.in">iittirupati@iittp.ac.in</Link>
                            </span>
                            </li>
                            <li>
                            <i className="icon fal fa-map-marker-check mb-3" />
                            <span>
                            {language==='en'?
                            (<>
                                Venkatagiri Road, Yerpedu Post,<br /> Tirupati District,<br /> Andhra Pradesh - 517619.
                            </>)
                            :
                            (<>
                                वेंकटगिरी रोड, एर्पेडु पोस्ट,<br /> तिरुपति जिला,<br /> आंध्र प्रदेश - 517619.
                            </>)}
                            </span>
                            </li>
                            
                        </ul>
                            
                        </div>
                        <div className="pt-3">
                            <Link to="/contact-iit" className="btn ss-btn smoth-scroll" style={{padding:"10px 15px"}}>
                                {language==='en'?'Read More':'और पढ़ें'}<i className="fal fa-long-arrow-right" />
                            </Link>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <Map />
            <div className="copyright-wrap">

                <div className="container position-relative second-footer">
                    
                            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-1">
                                <div className="d-flex align-items-center bg-event shadow-sm" style={{zIndex:1}}>
                                    <div className="logo">
                                        <Link to="/">
                                            <img width={85} src="assets/img/logo/logo.svg" alt="logo" />
                                        </Link>
                                    </div>
                                    <div className="logo2 ms-1">
                                        <div className="logo-text-hindi">
                                            <span>భారతీయ </span> 
                                            <span>సాంకేతిక </span> 
                                            <span>విజ్ఞాన </span>
                                            <span>సంస్థ </span>
                                            <span>తిరుపతి</span>
                                        </div>
                                        <div className="logo-text-hindi">
                                            <span>भारतीय </span> 
                                            <span>प्रौद्योगिकी </span>
                                            <span>संस्थान </span>
                                            <span>तिरुपति </span>
                                        </div>
                                        <div className="logo-text">
                                            <span>INDIAN </span>
                                            <span>INSTITUTE </span>
                                            <span>OF </span> 
                                            <span>TECHNOLOGY </span> 
                                            <span>TIRUPATI </span>
                                        </div>
                                        
                                    </div>
                                    {/* <span className="logo-text-telugu">ఇండియన్ ఇన్స్టిట్యూట్ ఆఫ్ టెక్నాలజీ తిరుపతి</span> */}
                                    
                                </div>

                                <div className=" text-right text-xl-right bg-red shadow-sm" style={{zIndex:1}}>
                                    <div>Copyright © 2024 Indian Institute of Technology Tirupati.</div> 
                                    <div className='lh-1'>All rights reserved.</div><br/>
                                    <div className='lh-1 small'>Developed & maintained by CC, IIT Tirupati.</div>
                                </div>
                                
                        </div>
                    </div>

            </div>

        </footer>
    </>
    )
}

export default Main;